import React, { useState, useEffect, useRef } from 'react';
import { 
  Video, VideoOff, Mic, MicOff, Users, Send, MessageCircle, 
  Settings, Maximize2, Volume2, VolumeX, Heart, Smile, 
  Camera, Monitor, Phone, PhoneOff, Plus, X, Lock, 
  Unlock, Crown, Eye, EyeOff, Share2, Sparkles, Zap,
  TrendingUp, Clock, Star, Award, Gift, Leaf, Filter,
  Search, Hash, Globe, AlertCircle, CheckCircle, ChevronUp, ChevronDown, UserPlus, Check,
  Image as ImageIcon  // Make sure this is included
} from 'lucide-react';
import { useUser } from '../context/UserContext';
import { useVideoChat  } from '../hooks/useSeshRooms';
import seshRoomApi from '../services/seshRoomApi';
import CreateSeshRoomModal from '../components/CreateSushRoomModal';
import { RemoteVideo } from '../components/RemoteVideo';
import VideoChat from './VideoChat';
import API_URL from '../config/ApiUrl';
import PrivateRoomsModal from '../components/PrivateRoomsRequestModal';
import InviteUsersModal from '../sesh_room_components/InviteUsersSeshRoomModal';
import JoinInvitationModal from '../sesh_room_components/JoinSeshRoomInvitemModal';
import { PendingInvitationsModal } from '../sesh_room_components/PendingInvitationModalComponent';
import { PendingRoomsManagementModal } from '../sesh_room_components/PendingRoomsManagementModal';
import { getSmokerEmoji } from '../static/SmokerEmoji';
import { useTheme } from '../arrangement/ThemeContext';

export function SeshRoomsPage() {
  const [currentRoom, setCurrentRoom] = useState(null);
  const [realTimeParticipants, setRealTimeParticipants] = useState(0);
  const [error, setError] = useState(null);
  const [rooms, setRooms] = useState([]);
  const { user, isAuthenticated } = useUser();
  const [showInviteModal, setShowInviteModal] = useState(false);
  const { colors } = useTheme();

  const [showInvitationModal, setShowInvitationModal] = useState(false);
  const [selectedInvitedRoom, setSelectedInvitedRoom] = useState(null);

  const [showPendingInvitations, setShowPendingInvitations] = useState(false);
  const [pendingInvitationsCount, setPendingInvitationsCount] = useState(0);

  // Mobile-specific states
  const [isMobile, setIsMobile] = useState(false);
  const [showMobileChat, setShowMobileChat] = useState(false);

  const [showGiphyPicker, setShowGiphyPicker] = useState(false);
  const [giphySearch, setGiphySearch] = useState('');
  const [giphyResults, setGiphyResults] = useState([]);
  const [giphyLoading, setGiphyLoading] = useState(false);
  const [selectedGif, setSelectedGif] = useState(null);

  const GIPHY_API_KEY = process.env.REACT_APP_GIPHY_API_KEY; // Replace with your actual key

  // Add these functions after your existing functions
  const searchGiphy = async (query) => {
    if (!query.trim()) {
      loadTrendingGifs();
      return;
    }

    setGiphyLoading(true);
    try {
      const response = await fetch(
        `https://api.giphy.com/v1/gifs/search?api_key=${GIPHY_API_KEY}&q=${encodeURIComponent(query)}&limit=20&rating=g`
      );
      const data = await response.json();
      setGiphyResults(data.data || []);
    } catch (error) {
      console.error('Failed to search GIPHY:', error);
    } finally {
      setGiphyLoading(false);
    }
  };

  const loadTrendingGifs = async () => {
    setGiphyLoading(true);
    try {
      const response = await fetch(
        `https://api.giphy.com/v1/gifs/trending?api_key=${GIPHY_API_KEY}&limit=20&rating=g`
      );
      const data = await response.json();
      setGiphyResults(data.data || []);
    } catch (error) {
      console.error('Failed to load trending GIFs:', error);
    } finally {
      setGiphyLoading(false);
    }
  };

  const openGiphyPicker = () => {
    console.log("OPEN GIOFFFF")
    setShowGiphyPicker(true);
    loadTrendingGifs();
  };

  const selectGif = (gif) => {
    setSelectedGif(gif);
    setShowGiphyPicker(false);
    setNewMessage(gif.id);
  };

  const clearSelectedGif = () => {
    setSelectedGif(null);
    setNewMessage('');
  };

  const {
    socket,
    isInRoom,
    roomUsers,
    remoteStreams,
    connectionStatus,
    localVideoRef,
    localStreamRef,
    peerConnectionsRef,
    joinRoom: joinVideoRoom,
    startScreenShare,
    callAllUsers,
    hasLocalStream,
    remoteStreamCount,
    forceReconnectToPeer
  } = useVideoChat(currentRoom?.id, user?.username);

  // UI State
  const [selectedRoom, setSelectedRoom] = useState(null);
  const [isVideoOn, setIsVideoOn] = useState(false);
  const [isAudioOn, setIsAudioOn] = useState(false);
  const [selectedMembership, setSelectedMembership] = useState('');
  const [showPrivateRooms, setShowPrivateRooms] = useState(false);
  const [newMessage, setNewMessage] = useState('');
  const [showCreateRoom, setShowCreateRoom] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [showOnlyLive, setShowOnlyLive] = useState(false);
  const [notification, setNotification] = useState(null);
  const [localStream, setLocalStream] = useState(null);

  const [showPendingRoomsManagement, setShowPendingRoomsManagement] = useState(false);
  const [pendingRoomsStats, setPendingRoomsStats] = useState({ incoming_requests: 0, outgoing_requests: 0, total_pending: 0 });


  const [userRole, setUserRole] = useState(null);
  const [pauseLoading, setPauseLoading] = useState(false);

  const messagesEndRef = useRef(null);
  const socketRef = useRef(null);

  console.log('showInviteModal current state:', showInviteModal);

  
  // Mobile detection
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Categories and other data arrays remain the same...
  const categories = [
    { id: '', name: 'All Categories', icon: '🌍' },
    { id: 'wake-bake', name: 'Wake & Bake', icon: '🌅' },
    { id: 'chill-sesh', name: 'Chill Sesh', icon: '😌' },
    { id: 'strain-review', name: 'Strain Reviews', icon: '🔍' },
    { id: 'dab-station', name: 'Dab Station', icon: '🔥' },
    { id: 'edible-experience', name: 'Edible Journey', icon: '🍪' },
    { id: 'grow-talk', name: 'Grow Talk', icon: '🌱' },
    { id: 'gaming-high', name: 'Gaming High', icon: '🎮' },
    { id: 'music-vibes', name: 'Music & Vibes', icon: '🎵' },
    { id: 'newbie-friendly', name: 'Newbie Corner', icon: '🤝' },
    { id: 'private-crew', name: 'Private Crew', icon: '🔒' }
  ];

  const membershipTypes = [
    { id: '', name: 'All Rooms', icon: '🌍' },
    { id: 'my-rooms', name: 'My Rooms', icon: '👤' },
    { id: 'creator', name: 'Created by Me', icon: '👑' },
    { id: 'admin', name: 'Admin', icon: '🛡️' },
    { id: 'member', name: 'Member', icon: '👥' },
    { id: 'viewer', name: 'Viewer', icon: '👁️' },
    { id: 'invited', name: 'Invited', icon: '📨' },
    { id: 'pending', name: 'Pending', icon: '⏳' }
  ];
  
  const handleInvitationResponse = async (response) => {
    console.log('___________--g-fs-fgds-g-fd-fdg-fg-gdf--')
    if (response.success) {
      showNotification(response.message);
      await fetchPendingInvitationsCount();
      if (response.action === 'accepted') {
        await fetchRooms(); // Refresh to update the room card
        
        // If room is live, automatically join it
        showNotification('You are now a member! You can join the room from the main page.');

      } else if (response.action === 'declined') {
        await fetchRooms(); // Remove the invitation from UI
      }
    } else {
      showNotification(response.message, 'error');
    }
  };

  // Your existing functions remain the same...
  const fetchRooms = async (filters = {}) => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      if (filters.category) params.append('category', filters.category);
      if (filters.is_live) params.append('is_live', 'true');
      if (filters.search) params.append('search', filters.search);
      if (filters.membership) params.append('membership', filters.membership);

      const response = await fetch(`${API_URL}/api/rooms?${params.toString()}`, {
        credentials: 'include'
      });
      if (response.ok) {
        const data = await response.json();
        setRooms(data.rooms || []);
        setError(null);
        if (isAuthenticated) {
          await fetchPendingInvitationsCount();
        }
      } else {
        setError('Failed to fetch rooms');
      }
    } catch (err) {
      setError('Failed to fetch rooms');
    } finally {
      setLoading(false);
    }
  };

  const fetchPendingRoomsStats = async () => {
    if (!isAuthenticated) return;
    
    try {
      const response = await fetch(`${API_URL}/api/rooms/manage-requests/stats`, {
        credentials: 'include'
      });
      if (response.ok) {
        const data = await response.json();
        setPendingRoomsStats(data.stats || { incoming_requests: 0, outgoing_requests: 0, total_pending: 0 });
      }
    } catch (error) {
      console.error('Failed to fetch pending rooms stats:', error);
    }
  };


  const fetchPendingInvitationsCount = async () => {
    if (!isAuthenticated) return;
    
    try {
      const response = await fetch(`${API_URL}/api/rooms?membership=invited`, {
        credentials: 'include'
      });
      if (response.ok) {
        const data = await response.json();
        setPendingInvitationsCount(data.rooms?.length || 0);
      }
    } catch (error) {
      console.error('Failed to fetch pending invitations count:', error);
    }
  };

  // All your existing useEffects and handlers remain the same...
  useEffect(() => {
    const filters = {};
    if (selectedCategory) filters.category = selectedCategory;
    if (showOnlyLive) filters.is_live = true;
    if (searchQuery) filters.search = searchQuery;
    if (selectedMembership) filters.membership = selectedMembership;
    
    fetchRooms(filters);
  }, [selectedCategory, showOnlyLive, searchQuery, selectedMembership]);

  useEffect(() => {
    if (socket && currentRoom) {
      socket.emit('get-messages', { roomId: currentRoom.id });
    }
  }, [socket, currentRoom]);

  useEffect(() => {
    if (isAuthenticated) {
      fetchPendingInvitationsCount();
    }
  }, [isAuthenticated]);

  useEffect(() => {
    if (isAuthenticated) {
      fetchPendingRoomsStats();
    }
  }, [isAuthenticated]);

  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ 
        behavior: 'smooth',
        block: 'end'
      });
    }
  }, [messages]);

  useEffect(() => {
    if (currentRoom && messagesEndRef.current) {
      setTimeout(() => {
        messagesEndRef.current?.scrollIntoView({ 
          behavior: 'smooth',
          block: 'end'
        });
      }, 100);
    }
  }, [currentRoom]);

  const scrollToBottom = () => {
    const messagesContainer = messagesEndRef.current?.parentElement;
    if (messagesContainer) {
      messagesContainer.scrollTop = messagesContainer.scrollHeight;
    }
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const showNotification = (message, type = 'success') => {
    setNotification({ message, type });
    setTimeout(() => setNotification(null), 5000);
  };

  const getUsernameFromSocketId = (socketId) => {
    if (socketId === socket?.id) {
      return user?.username || 'You';
    }
    return `User ${socketId?.slice(-4) || 'Unknown'}`;
  };

  const handleCreateRoom = async (roomData) => {
    try {
      const response = await seshRoomApi.createRoom(roomData);
      
      if (response.room) {
        showNotification(`Sesh room "${response.room.title}" created successfully! 🎉`);
        await fetchRooms();
        return response;
      }
      
      return response;
      
    } catch (error) {
      console.error('💥 handleCreateRoom failed:', error);
      throw error;
    }
  };

  const pauseRoomStream = async () => {
    if (!currentRoom) return;
    setPauseLoading(true);
    try {
      const response = await fetch(`${API_URL}/api/rooms/${currentRoom.id}/pause-stream`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include'
      });
      
      const data = await response.json();
      if (data.success) {
        setCurrentRoom({ ...currentRoom, is_live: false });
        showNotification('Room has been paused');
      } else {
        showNotification(data.error || 'Failed to pause room', 'error');
      }
    } catch (error) {
      console.error('Error pausing room:', error);
      showNotification('Failed to pause room', 'error');
    } finally {
      setPauseLoading(false);
    }
  };

  const handleJoinRoom = async (room, isPublic ) => {

    console.log('IS isPublic ROOM: ', isPublic)
    console.log('ROOM:', room)
    try {
      let response;
      if (isPublic){
        response = await fetch(`${API_URL}/api/rooms/${room.id}/join-public`, {
        method: 'POST',
        credentials: 'include'
      });
      }else {
      response = await fetch(`${API_URL}/api/rooms/${room.id}/join-private`, {
        method: 'POST',
        credentials: 'include'
      });
      
      }

      
      if (!response.ok) {
        const error = await response.json();
        showNotification(error.error || 'Failed to join room', 'error');
        return;
      }
      
      const data = await response.json();
      
      setSelectedRoom(room);
      setCurrentRoom(room);
      setUserRole(data.role); // ADD THIS LINE TO CAPTURE ROLE
      joinVideoRoom();
      showNotification(data.message);
      
    } catch (error) {
      console.error('Failed to join room:', error);
      showNotification('Failed to join room', 'error');
    }
  };

  const handleLeaveRoom = async () => {
    try {
      if (currentRoom) {
        setSelectedRoom(null);
        setLocalStream(null);
        setIsVideoOn(false);
        setIsAudioOn(false);
        setShowMobileChat(false); // Close mobile chat when leaving
        showNotification('Left the sesh room');
      }
    } catch (error) {
      console.error('Failed to leave room:', error);
    }
  };

  const handleVideoToggle = async () => {
    try {
      if (!localStream) {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: true,
          audio: true
        });
        
        setLocalStream(stream);
        setIsVideoOn(true);
        setIsAudioOn(true);
        
        try {
          const activeStreams = await fetch(`/api/rooms/${currentRoom.id}/streams`, {
            credentials: 'include'
          }).then(r => r.json());
          
          if (activeStreams.active_streams?.length > 0) {
            const streamId = activeStreams.active_streams[0].id;
            
            await fetch(`/api/rooms/${currentRoom.id}/streams/${streamId}/join`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              credentials: 'include',
              body: JSON.stringify({ role: 'participant' })
            });
          }
          
        } catch (error) {
          console.error('❌ Failed to connect to other users:', error);
        }
        
        showNotification('📹 Video enabled!');
        return;
      }
      
    } catch (err) {
      console.error('❌ VIDEO FAILED:', err);
      showNotification(`Video failed: ${err.message}`, 'error');
    }
  };

  const handleAudioToggle = async () => {
    try {
      if (localStream) {
        const audioTrack = localStream.getAudioTracks()[0];
        if (audioTrack) {
          audioTrack.enabled = !audioTrack.enabled;
          setIsAudioOn(audioTrack.enabled);
          
          Object.values(peerConnectionsRef.current).forEach(pc => {
            const sender = pc.getSenders().find(s => 
              s.track && s.track.kind === 'audio'
            );
            if (sender && audioTrack) {
              sender.replaceTrack(audioTrack);
            }
          });
        }
      }
    } catch (err) {
      console.error('Failed to toggle audio:', err);
      showNotification('Failed to toggle audio', 'error');
    }
  };

    const handleSendMessage = async () => {
    if (newMessage.trim() && currentRoom && socket) {
      const msgType = selectedGif ? 'gif' : 'text';
      const messageContent = selectedGif ? selectedGif.id : newMessage.trim();
      
      console.log('Sending message:', {
        roomId: currentRoom.id,
        message: messageContent,
        msg_type: msgType
      });
      
      socket.emit('send-message', {
        roomId: currentRoom.id,
        message: messageContent,
        msg_type: msgType
      });
      
      setNewMessage('');
      setSelectedGif(null);
      
      if (isMobile) {
        setTimeout(() => setShowMobileChat(false), 1000);
      }
    }
  };

  const handleStreamToggle = async () => {
    if (!currentRoom) return;
    
    try {
      if (currentRoom.is_live) {
        showNotification('Stream stopped');
      } else {
        showNotification('Stream started! 🔴');
      }
    } catch (err) {
      console.error('Failed to toggle stream:', err);
      showNotification('Failed to toggle stream', 'error');
    }
  };
  const [processedMessageIds, setProcessedMessageIds] = useState(new Set());


  useEffect(() => {
    if (socket && currentRoom) {
      socket.off('new-message');
      socket.off('messages-loaded');
      socket.off('message-error');
      
      socket.emit('join-message-room', { roomId: currentRoom.id });
      
      socket.on('new-message', (messageData) => {
        setProcessedMessageIds(prevIds => {
          if (prevIds.has(messageData.id)) {
            console.log('DUPLICATE MESSAGE BLOCKED:', messageData.id);
            return prevIds;
          }
          
          setMessages(prev => [...prev, messageData]);
          return new Set([...prevIds, messageData.id]);
        });
      });

      socket.on('messages-loaded', (data) => {
        setMessages(data.messages || []);
        // Reset processed IDs when loading fresh messages
        setProcessedMessageIds(new Set(data.messages?.map(msg => msg.id) || []));
      });

      socket.on('message-error', (error) => {
        console.error('MESSAGE ERROR:', error);
        showNotification(error.error, 'error');
      });

      socket.emit('get-messages', { roomId: currentRoom.id });

      return () => {
        socket.off('new-message');
        socket.off('messages-loaded');
        socket.off('message-error');
      };
    }
  }, [socket, currentRoom]);

  const filteredRooms = rooms.filter(room => {
    if (searchQuery) {
      const query = searchQuery.toLowerCase();
      return (
        room.title.toLowerCase().includes(query) ||
        room.host?.username.toLowerCase().includes(query) ||
        room.strain?.toLowerCase().includes(query) ||
        room.tags.some(tag => tag.toLowerCase().includes(query))
      );
    }
    return true;
  });


  console.log('CONOR HERE: ')
  console.log('CONOR HERE: ', currentRoom)
  console.log('CONOR HERE: ', !currentRoom?.is_public)
  console.log('CONOR HERE: ',userRole)

  // If in a room, show room view with mobile responsiveness
  if (selectedRoom && currentRoom) {
    // let userRole = 'owner';
    // userRole = 'host';
    const isHost = userRole === 'creator' || userRole === 'admin';
    const canVideo = ['participant', 'host', 'creator', 'admin', 'member'].includes(userRole);

    return (
      <div style={{
        minHeight: '100vh',
        backgroundColor: '#0a0a0a',
        color: 'white',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        position: 'relative'
      }}>
        {/* Notification */}
        {notification && (
          <div style={{
            position: 'fixed',
            top: '20px',
            right: '20px',
            zIndex: 1001,
            padding: '16px 20px',
            background: notification.type === 'error' ? '#ef4444' : '#00d4aa',
            color: 'white',
            borderRadius: '12px',
            boxShadow: '0 8px 24px rgba(0, 0, 0, 0.3)',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}>
            {notification.type === 'error' ? (
              <AlertCircle size={20} />
            ) : (
              <CheckCircle size={20} />
            )}
            {notification.message}
          </div>
        )}

        {/* Room Header */}
        <div style={{
          background: colors.bgTertiary,
          borderBottom: '2px solid #333',
          padding: isMobile ? '12px 16px' : '16px 24px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: isMobile ? 'wrap' : 'nowrap'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flex: 1, minWidth: 0 }}>
            <button
              onClick={handleLeaveRoom}
              style={{
                padding: '8px',
                background: '#ef4444',
                border: 'none',
                borderRadius: '12px',
                cursor: 'pointer',
                color: 'white'
              }}
            >
              <X size={20} />
            </button>
            <div style={{ minWidth: 0, flex: 1 }}>
              <h2 style={{ 
                margin: 0, 
                fontSize: isMobile ? '16px' : '20px', 
                fontWeight: '600',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
              }}>
                {currentRoom.title}
              </h2>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '4px', flexWrap: 'wrap' }}>
                <span style={{ fontSize: isMobile ? '12px' : '14px', color: '#888', whiteSpace: 'nowrap' }}>
                  {isMobile ? currentRoom.host?.username : `Hosted by ${currentRoom.host?.username}`}
                </span>
                {currentRoom.is_live && (
                  <span style={{ 
                    padding: '2px 6px', 
                    background: '#00d4aa', 
                    borderRadius: '6px', 
                    fontSize: '10px', 
                    fontWeight: '600' 
                  }}>
                    LIVE
                  </span>
                )}
                 {currentRoom.is_live && userRole && ['creator', 'admin'].includes(userRole) && (
                    <button
                      onClick={pauseRoomStream}
                      disabled={pauseLoading}
                      style={{
                        padding: '2px 8px',
                        background: '#ef4444',
                        border: 'none',
                        borderRadius: '6px',
                        cursor: pauseLoading ? 'not-allowed' : 'pointer',
                        color: 'white',
                        fontSize: '10px',
                        fontWeight: '600',
                        opacity: pauseLoading ? 0.7 : 1,
                        display: 'flex',
                        alignItems: 'center',
                        gap: '4px'
                      }}
                    >
                      {pauseLoading ? 'Pausing...' : 'Pause Sesh'}
                    </button>
                  )}
                {currentRoom.strain && (
                  <span style={{ 
                    padding: '2px 6px', 
                    background: '#10b981', 
                    borderRadius: '6px', 
                    fontSize: '10px', 
                    fontWeight: '500',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '2px'
                  }}>
                    🌿 {currentRoom.strain}
                  </span>
                )}
                {/* ADD PAUSE BUTTON HERE */}
              </div>
            </div>
          </div>
          
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: isMobile ? '8px' : '0' }}>
            {isHost && !isMobile && (
              <button
                onClick={handleStreamToggle}
                style={{
                  padding: '6px 12px',
                  background: currentRoom.is_live ? '#ef4444' : '#00d4aa',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  color: 'white',
                  fontSize: '11px',
                  fontWeight: '600'
                }}
              >
                {currentRoom.is_live ? 'Stop' : 'Start'}
              </button>
            )}
            {userRole && ['creator', 'admin', 'member'].includes(userRole) && (
            // {!currentRoom.is_public && userRole && ['creator', 'admin', 'member'].includes(userRole) && (
              console.log('Rendering invite button'),
              <button
                onClick={() => {
                  console.log('Invite button clicked, setting showInviteModal to true');
                  setShowInviteModal(true)
                }}
                style={{
                  padding: '6px 12px',
                  background: '#8b5cf6',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  color: 'white',
                  fontSize: '11px',
                  fontWeight: '600',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px'
                }}
              >
                <UserPlus size={12} />
                {isMobile ? 'Invite' : 'Invite Users'}
              </button>
            )}
            <div style={{ display: 'flex', alignItems: 'center', gap: '4px', color: '#888' }}>
              <Users size={14} />
              <span style={{ fontSize: '12px' }}>{realTimeParticipants}/{currentRoom.max_participants}</span>
            </div>
            {!isMobile && currentRoom.is_public && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '4px', color: '#888' }}>
                <Eye size={14} />
                <span style={{ fontSize: '12px' }}>{currentRoom.viewer_count}</span>
              </div>
            )}
          </div>
        </div>

        {/* Mobile Chat Toggle Button */}
        {isMobile && (
          <button
            onClick={() => setShowMobileChat(!showMobileChat)}
            style={{
              position: 'fixed',
              top: '80px',
              right: '16px',
              zIndex: 1000,
              padding: '12px',
              background: showMobileChat ? '#ef4444' : '#00d4aa',
              border: 'none',
              borderRadius: '50%',
              cursor: 'pointer',
              color: 'white',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <MessageCircle size={20} />
          </button>
        )}

        {/* Main Content Area */}
        <div style={{ 
          display: 'flex',
          height: 'calc(100vh - 80px)',
          position: 'relative'
        }}>
          {/* Video Area - Full width on mobile, shared on desktop */}
          <div style={{
            width: isMobile ? '100%' : 'calc(100% - 400px)',
            height: '100%',
            background: colors.bgTertiary,
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '8px',
            padding: isMobile ? '10px' : '20px',
            overflowY: 'auto'
          }}>
            {/* Your Video */}
            {localStream && (
              <div style={{
                position: 'relative',
                background: '#000',
                borderRadius: '8px',
                overflow: 'hidden',
                aspectRatio: isMobile ? '16/9' : '16/9',
                maxHeight: isMobile ? '250px' : 'none'
              }}>
                <video
                  ref={(video) => {
                    if (video && localStream) {
                      video.srcObject = localStream;
                      if (localStream.isLocalStream) {
                        video.muted = true;
                      }
                    }
                  }}
                  autoPlay
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover'
                  }}
                />
                <div style={{
                  position: 'absolute',
                  bottom: '8px',
                  left: '8px',
                  background: 'rgba(0, 0, 0, 0.7)',
                  color: 'white',
                  padding: '4px 8px',
                  borderRadius: '4px',
                  fontSize: isMobile ? '10px' : '12px',
                  fontWeight: '600'
                }}>
                  {user?.username} (You)
                </div>
                
                <div style={{
                  position: 'absolute',
                  bottom: '8px',
                  right: '8px',
                  display: 'flex',
                  gap: '4px'
                }}>
                  <div style={{
                    width: isMobile ? '20px' : '24px',
                    height: isMobile ? '20px' : '24px',
                    background: isAudioOn ? '#00d4aa' : '#ef4444',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    {isAudioOn ? <Mic size={isMobile ? 10 : 12} style={{color: 'white'}} /> : <MicOff size={isMobile ? 10 : 12} style={{color: 'white'}} />}
                  </div>
                  <div style={{
                    width: isMobile ? '20px' : '24px',
                    height: isMobile ? '20px' : '24px',
                    background: isVideoOn ? '#00d4aa' : '#ef4444',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    {isVideoOn ? <Video size={isMobile ? 10 : 12} style={{color: 'white'}} /> : <VideoOff size={isMobile ? 10 : 12} style={{color: 'white'}} />}
                  </div>
                </div>
              </div>
            )}

            {/* Remote Videos */}
            {Object.entries(remoteStreams).map(([userId, stream]) => {
              const username = getUsernameFromSocketId(userId);
              return (
                <div key={userId} style={{
                  position: 'relative',
                  background: '#000',
                  borderRadius: '8px',
                  overflow: 'hidden',
                  aspectRatio: '16/9',
                  maxHeight: isMobile ? '250px' : 'none'
                }}>
                  <RemoteVideo 
                    userId={userId} 
                    username={username} 
                    stream={stream}
                    onReconnectRequest={forceReconnectToPeer}
                    isMobile={isMobile}
                  />
                </div>
              );
            })}

            <VideoChat 
              title={currentRoom.title}
              onParticipantCountChange={setRealTimeParticipants}
              currentUser={user}
              onNewMessage={(messageData) => {
                setMessages(prev => [...prev, messageData]);
              }}
              onMessagesLoaded={(data) => {
                setMessages(data.messages);
              }}
              onMessageError={(error) => {
                console.error('❌ Message error:', error);
                showNotification(error.error, 'error');
              }}
            />
          </div>

          {/* Chat Sidebar - Hidden on mobile unless toggled */}
          <div style={{
            width: isMobile ? '100%' : '400px',
            height: '100%',
            background: colors.bgTertiary,
            borderLeft: isMobile ? 'none' : '2px solid #333',
            display: 'flex',
            flexDirection: 'column',
            position: isMobile ? 'fixed' : 'relative',
            top: isMobile ? '0' : 'auto',
            right: isMobile ? (showMobileChat ? '0' : '-100%') : 'auto',
            zIndex: isMobile ? 999 : 'auto',
            transition: isMobile ? 'right 0.3s ease' : 'none'
          }}>
            {/* Chat Header */}
            <div style={{
              padding: '16px',
              borderBottom: `1px solid ${colors.border}`,
              background: colors.bgCard,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}>
              <div>
                <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '600' }}>
                  Sesh Chat
                </h3>
                <p style={{ margin: '4px 0 0 0', fontSize: '12px', color: '#888' }}>
                  {messages.length} messages • {realTimeParticipants} participants
                </p>
              </div>
              {isMobile && (
                <button
                  onClick={() => setShowMobileChat(false)}
                  style={{
                    padding: '8px',
                    background: 'transparent',
                    border: 'none',
                    color: '#888',
                    cursor: 'pointer'
                  }}
                >
                  <X size={20} />
                </button>
              )}
            </div>

            {/* Messages */}
            <div style={{
              flex: 1,
              overflowY: 'auto',
              padding: '16px',
              display: 'flex',
              flexDirection: 'column',
              gap: '12px',
              maxHeight: isMobile ? 'calc(100vh - 200px)' : 'calc(100vh - 200px)',
              scrollBehavior: 'smooth'
            }}>
              {messages.map((message) => (
                <div key={message.id} style={{
                  display: 'flex',
                  gap: '12px',
                  padding: '8px',
                  borderRadius: '8px',
                  background: message.author?.id === currentRoom.host?.id ? 'rgba(0, 212, 170, 0.1)' : 'transparent',
                  border: message.author?.id === currentRoom.host?.id ? '1px solid rgba(0, 212, 170, 0.2)' : 'none'
                }}>
                  <img
                    src={message.cover_image_url || message.author?.profile_image_url}
                    alt={message.author?.username}
                    style={{
                      width: isMobile ? '28px' : '32px',
                      height: isMobile ? '28px' : '32px',
                      borderRadius: '50%',
                      objectFit: 'cover'
                    }}
                  />
                  <div style={{ flex: 1 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                      <span style={{ 
                        fontSize: isMobile ? '11px' : '12px', 
                        fontWeight: '600', 
                        color: message.author?.id === currentRoom.host?.id ? '#00d4aa' : '#e5e5e5' 
                      }}>
                        {message.display_name || message.author?.username}
                      </span>
                      {message.author?.id === currentRoom.host?.id && (
                        <Crown size={10} style={{ color: '#fbbf24' }} />
                      )}
                      <span style={{ fontSize: '9px', color: '#888' }}>
                        {new Date(message.created_at).toLocaleTimeString()}
                      </span>
                    </div>
                    {message.message_type === 'gif' ? (
                      <div style={{ marginTop: '4px' }}>
                        <img
                          src={`https://media.giphy.com/media/${message.content}/giphy.gif`}
                          alt="GIF"
                          style={{
                            maxWidth: isMobile ? '200px' : '250px',
                            borderRadius: '8px',
                            display: 'block'
                          }}
                        />
                      </div>
                    ) : (
                      <p style={{ margin: 0, fontSize: isMobile ? '13px' : '14px', lineHeight: '1.4', color: '#e5e5e5' }}>
                        {message.content}
                      </p>
                    )}
                    {message.reactions && message.reactions.length > 0 && (
                      <div style={{ marginTop: '4px', display: 'flex', gap: '4px' }}>
                        {message.reactions.map((reaction, i) => (
                          <span key={i} style={{ fontSize: '12px' }}>{reaction}</span>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              ))}
              <div ref={messagesEndRef} style={{ height: '1px' }} />
            </div>

            {/* Message Input */}
            <div style={{
              padding: '16px',
              borderTop: '1px solid #333',
              background: '#2a2a2a'
            }}>
              {/* GIF Preview */}
              {selectedGif && (
                <div style={{ 
                  position: 'relative', 
                  marginBottom: '12px',
                  display: 'inline-block'
                }}>
                  <img
                    src={selectedGif.images.fixed_height_small.url}
                    alt="Selected GIF"
                    style={{
                      maxWidth: isMobile ? '150px' : '200px',
                      borderRadius: '8px'
                    }}
                  />
                  <button
                    onClick={clearSelectedGif}
                    style={{
                      position: 'absolute',
                      top: '4px',
                      right: '4px',
                      background: 'rgba(0, 0, 0, 0.8)',
                      border: 'none',
                      borderRadius: '50%',
                      width: '24px',
                      height: '24px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: 'pointer',
                      color: 'white'
                    }}
                  >
                    <X size={14} />
                  </button>
                </div>
              )}
              
              <div style={{ display: 'flex', gap: '8px' }}>
                <input
                  type="text"
                  value={newMessage}
                  onChange={(e) => setNewMessage(e.target.value)}
                  onKeyPress={(e) => e.key === 'Enter' && handleSendMessage()}
                  placeholder="Send a message to the sesh..."
                  style={{
                    flex: 1,
                    padding: isMobile ? '10px' : '12px',
                    background: colors.bgTertiary,
                    border: '1px solid #333',
                    borderRadius: '8px',
                    color: 'white',
                    fontSize: isMobile ? '14px' : '14px',
                    outline: 'none'
                  }}
                />
                <button
                onClick={openGiphyPicker}
                style={{
                  padding: isMobile ? '10px' : '12px',
                  background: '#8b5cf6',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  color: 'white'
                }}
              >
                <ImageIcon size={16} />
              </button>
                <button
                  onClick={handleSendMessage}
                  style={{
                    padding: isMobile ? '10px' : '12px',
                    background: '#00d4aa',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    color: 'white'
                  }}
                >
                  <Send size={16} />
                </button>
              </div>
              
              {/* Quick Reactions */}
              <div style={{ 
                marginTop: '8px', 
                display: 'flex', 
                gap: isMobile ? '6px' : '8px',
                justifyContent: 'center',
                flexWrap: 'wrap'
              }}>
                {['🔥', '💚', '😂', '🌿', '👍', '💯'].map((emoji) => (
                  <button
                    key={emoji}
                    onClick={() => setNewMessage(prev => prev + emoji)}
                    style={{
                      padding: isMobile ? '6px 8px' : '4px 8px',
                      background: 'transparent',
                      border: '1px solid #333',
                      borderRadius: '6px',
                      cursor: 'pointer',
                      fontSize: isMobile ? '16px' : '14px',
                      transition: 'all 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = '#333';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = 'transparent';
                    }}
                  >
                    {emoji}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Floating Video Controls - Adapted for mobile */}
        {localStream && canVideo && (
          <div style={{
            position: 'fixed',
            bottom: isMobile ? '20px' : '140px',
            left: isMobile ? '50%' : '20%',
            transform: isMobile ? 'translateX(-50%)' : 'translateX(-50%)',
            display: 'flex',
            gap: isMobile ? '8px' : '12px',
            background: 'rgba(0, 0, 0, 0.8)',
            padding: isMobile ? '12px' : '16px',
            borderRadius: isMobile ? '12px' : '16px',
            backdropFilter: 'blur(10px)',
            zIndex: 100
          }}>
            <button
              onClick={handleVideoToggle}
              style={{
                padding: isMobile ? '10px' : '12px',
                background: isVideoOn ? '#00d4aa' : '#ef4444',
                border: 'none',
                borderRadius: isMobile ? '10px' : '12px',
                cursor: 'pointer',
                color: 'white',
                transition: 'all 0.3s ease'
              }}
            >
              {isVideoOn ? <Video size={isMobile ? 18 : 20} /> : <VideoOff size={isMobile ? 18 : 20} />}
            </button>

            <button
              onClick={handleAudioToggle}
              style={{
                padding: isMobile ? '10px' : '12px',
                background: isAudioOn ? '#00d4aa' : '#ef4444',
                border: 'none',
                borderRadius: isMobile ? '10px' : '12px',
                cursor: 'pointer',
                color: 'white',
                transition: 'all 0.3s ease'
              }}
            >
              {isAudioOn ? <Mic size={isMobile ? 18 : 20} /> : <MicOff size={isMobile ? 18 : 20} />}
            </button>

            {!isMobile && (
              <>
                <button
                  style={{
                    padding: '12px',
                    background: '#333',
                    border: 'none',
                    borderRadius: '12px',
                    cursor: 'pointer',
                    color: 'white'
                  }}
                >
                  <Settings size={20} />
                </button>
                
                <button
                  onClick={startScreenShare}
                  style={{
                    padding: '12px',
                    background: '#ff9800',
                    border: 'none',
                    borderRadius: '12px',
                    cursor: 'pointer',
                    color: 'white',
                    transition: 'all 0.3s ease'
                  }}
                >
                  <Monitor size={20} />
                </button>

                <button
                  onClick={callAllUsers}
                  style={{
                    padding: '12px',
                    background: '#4caf50',
                    border: 'none',
                    borderRadius: '12px',
                    cursor: 'pointer',
                    color: 'white',
                    transition: 'all 0.3s ease'
                  }}
                >
                  <Phone size={20} />
                </button>
              </>
            )}
          </div>
        )}
         <InviteUsersModal
        isOpen={showInviteModal}
        onClose={() => setShowInviteModal(false)}
        currentRoom={currentRoom}
        currentUser={user}
        onInviteSuccess={(data) => {
          showNotification(`User invited successfully!`);
        }}
      />
      {showGiphyPicker && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          zIndex: 2000,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '20px'
        }}>
          <div style={{
            width: '100%',
            maxWidth: isMobile ? '100%' : '600px',
            maxHeight: isMobile ? '100%' : '70vh',
            background: colors.bgTertiary1,
            borderRadius: '16px',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            boxShadow: '0 20px 60px rgba(0, 0, 0, 0.5)'
          }}>
            {/* Header */}
            <div style={{
              padding: '16px',
              borderBottom: '1px solid #333',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              background: colors.bgTertiary,
              flexShrink: 0
            }}>
              <h3 style={{ margin: 0, color: 'white', fontSize: '18px' }}>Choose a GIF</h3>
              <button
                onClick={() => {
                  setShowGiphyPicker(false);
                  setGiphySearch('');
                }}
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#888',
                  cursor: 'pointer',
                  padding: '8px'
                }}
              >
                <X size={24} />
              </button>
            </div>

            {/* Search Bar */}
            <div style={{ 
              padding: '16px', 
              background: colors.bgTertiary,
              flexShrink: 0
            }}>
              <div style={{ position: 'relative' }}>
                <Search
                  size={18}
                  style={{
                    position: 'absolute',
                    left: '12px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    color: '#888'
                  }}
                />
                <input
                  type="text"
                  value={giphySearch}
                  onChange={(e) => {
                    setGiphySearch(e.target.value);
                    searchGiphy(e.target.value);
                  }}
                  placeholder="Search GIPHY..."
                  style={{
                    width: '100%',
                    padding: '12px 12px 12px 40px',
                    border: '1px solid #333',
                    borderRadius: '12px',
                    background: colors.bgCard,
                    color: '#e5e5e5',
                    fontSize: '16px',
                    outline: 'none',
                    boxSizing: 'border-box'
                  }}
                />
              </div>
            </div>

            {/* GIF Grid */}
            <div style={{
              flex: 1,
              overflowY: 'auto',
              padding: '16px',
              background: colors.bgPrimary
            }}>
              {giphyLoading ? (
                <div style={{ textAlign: 'center', padding: '48px', color: '#888' }}>
                  Loading GIFs...
                </div>
              ) : (
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(2, 1fr)',
                  gap: '12px'
                }}>
                  {giphyResults.map((gif) => (
                    <div
                      key={gif.id}
                      onClick={() => selectGif(gif)}
                      style={{
                        cursor: 'pointer',
                        borderRadius: '8px',
                        overflow: 'hidden',
                        transition: 'transform 0.2s ease',
                        border: '2px solid transparent'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'scale(1.05)';
                        e.currentTarget.style.borderColor = '#00d4aa';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'scale(1)';
                        e.currentTarget.style.borderColor = 'transparent';
                      }}
                    >
                      <img
                        src={gif.images.fixed_height.url}
                        alt={gif.title}
                        style={{
                          width: '100%',
                          height: 'auto',
                          display: 'block'
                        }}
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      </div>
    );
  }

  // Main rooms list view - keep existing desktop layout but add mobile responsiveness
  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#0a0a0a',
      color: 'white',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    }}>
      {/* Notification */}
      {notification && (
        <div style={{
          position: 'fixed',
          top: '20px',
          right: '20px',
          zIndex: 1001,
          padding: '16px 20px',
          background: notification.type === 'error' ? '#ef4444' : '#00d4aa',
          color: 'white',
          borderRadius: '12px',
          boxShadow: '0 8px 24px rgba(0, 0, 0, 0.3)',
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}>
          {notification.type === 'error' ? (
            <AlertCircle size={20} />
          ) : (
            <CheckCircle size={20} />
          )}
          {notification.message}
        </div>
      )}

      <div style={{ maxWidth: '1400px', margin: '0 auto', padding: isMobile ? '16px' : '24px' }}>
        {/* Header - Mobile responsive */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: isMobile ? '24px' : '32px',
          background: colors.bgTertiary,
          padding: isMobile ? '20px' : '24px 32px',
          borderRadius: '20px',
          border: '1px solid #333',
          flexDirection: isMobile ? 'column' : 'row',
          gap: isMobile ? '16px' : '0'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px', textAlign: isMobile ? 'center' : 'left' }}>
            <div style={{
              width: isMobile ? '50px' : '60px',
              height: isMobile ? '50px' : '60px',
              background: 'linear-gradient(135deg, #00d4aa 0%, #10b981 100%)',
              borderRadius: '20px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 8px 20px rgba(16, 185, 129, 0.3)'
            }}>
              <Leaf size={isMobile ? 28 : 32} style={{ color: 'white' }} />
            </div>
            <div>
              <h1 style={{
                margin: 0,
                fontSize: isMobile ? '24px' : '32px',
                fontWeight: '800',
                background: 'linear-gradient(135deg, #00d4aa 0%, #10b981 100%)',
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }}>
                Cannabis Sesh Rooms
              </h1>
              <p style={{ margin: 0, color: '#888', fontSize: isMobile ? '14px' : '16px' }}>
                Connect, smoke, and vibe with the community 🌿
              </p>
            </div>
          </div>
          
          {isAuthenticated ? (
            <div style={{ 
              display: 'flex', 
              gap: isMobile ? '8px' : '12px',
              flexDirection: isMobile ? 'column' : 'row',
              width: isMobile ? '100%' : 'auto'
            }}>
              {pendingRoomsStats.total_pending > 0 && (
                <button
                  onClick={() => setShowPendingRoomsManagement(true)}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '12px',
                    padding: isMobile ? '12px 20px' : '16px 24px',
                    background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '16px',
                    cursor: 'pointer',
                    fontSize: isMobile ? '14px' : '16px',
                    fontWeight: '600',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 4px 12px rgba(59, 130, 246, 0.4)',
                    position: 'relative'
                  }}
                >
                  <Settings size={18} />
                  {isMobile ? 'Manage' : 'Manage Requests'}
                  <span style={{
                    position: 'absolute',
                    top: '-8px',
                    right: '-8px',
                    background: '#ef4444',
                    color: 'white',
                    borderRadius: '50%',
                    width: '20px',
                    height: '20px',
                    fontSize: '10px',
                    fontWeight: '700',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: '2px solid #1a1a1a'
                  }}>
                    {pendingRoomsStats.total_pending}
                  </span>
                </button>
              )}
              {/* Add the Pending Invitations button here - only shows if count > 0 */}
              {pendingInvitationsCount > 0 && (
                <button
                  onClick={() => setShowPendingInvitations(true)}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '12px',
                    padding: isMobile ? '12px 20px' : '16px 24px',
                    background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '16px',
                    cursor: 'pointer',
                    fontSize: isMobile ? '14px' : '16px',
                    fontWeight: '600',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 4px 12px rgba(245, 158, 11, 0.4)',
                    position: 'relative'
                  }}
                >
                  <UserPlus size={18} />
                  {isMobile ? 'Invitations' : 'Pending Invitations'}
                  <span style={{
                    position: 'absolute',
                    top: '-8px',
                    right: '-8px',
                    background: '#ef4444',
                    color: 'white',
                    borderRadius: '50%',
                    width: '20px',
                    height: '20px',
                    fontSize: '10px',
                    fontWeight: '700',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: '2px solid #1a1a1a'
                  }}>
                    {pendingInvitationsCount}
                  </span>
                </button>
              )}

              {/* Your existing buttons remain exactly the same */}
              <button
                onClick={() => setShowPrivateRooms(true)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '12px',
                  padding: isMobile ? '12px 20px' : '16px 24px',
                  background: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '16px',
                  cursor: 'pointer',
                  fontSize: isMobile ? '14px' : '16px',
                  fontWeight: '600',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 4px 12px rgba(139, 92, 246, 0.4)'
                }}
              >
                <Search size={18} />
                Private Rooms
              </button>
                                  
              <button
                onClick={() => setShowCreateRoom(true)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '12px',
                  padding: isMobile ? '12px 20px' : '16px 24px',
                  background: 'linear-gradient(135deg, #00d4aa 0%, #10b981 100%)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '16px',
                  cursor: 'pointer',
                  fontSize: isMobile ? '14px' : '16px',
                  fontWeight: '600',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 4px 12px rgba(16, 185, 129, 0.4)'
                }}
              >
                <Plus size={18} />
                Start Sesh Room
              </button>
            </div>
          ) : (
            <div style={{
              padding: '12px 20px',
              background: 'rgba(255, 255, 255, 0.1)',
              borderRadius: '12px',
              color: '#888',
              fontSize: '14px'
            }}>
              Login to create rooms
            </div>
          )}
        </div>

        {/* Search and Filters - Mobile responsive */}
        <div style={{
          display: 'flex',
          gap: '16px',
          marginBottom: isMobile ? '24px' : '32px',
          flexWrap: 'wrap',
          alignItems: 'center',
          flexDirection: isMobile ? 'column' : 'row'
        }}>
          {/* Search */}
          <div style={{ position: 'relative', flex: '1', minWidth: isMobile ? '100%' : '300px' }}>
            <Search size={20} style={{
              position: 'absolute',
              left: '16px',
              top: '50%',
              transform: 'translateY(-50%)',
              color: '#888'
            }} />
            <input
              type="text"
              placeholder="Search rooms, hosts, strains..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              style={{
                width: '100%',
                paddingLeft: '48px',
                paddingRight: '16px',
                paddingTop: '12px',
                paddingBottom: '12px',
                background: 'rgba(255, 255, 255, 0.1)',
                border: '1px solid rgba(255, 255, 255, 0.2)',
                borderRadius: '12px',
                color: 'white',
                fontSize: '14px',
                outline: 'none',
                boxSizing: 'border-box'
              }}
            />
          </div>
          
          <div style={{ 
            display: 'flex', 
            gap: '12px',
            width: isMobile ? '100%' : 'auto',
            flexWrap: 'wrap'
          }}>
            <select
              value={selectedMembership}
              onChange={(e) => setSelectedMembership(e.target.value)}
              style={{
                padding: '12px 16px',
                background: 'rgba(255, 255, 255, 0.1)',
                border: '1px solid rgba(255, 255, 255, 0.2)',
                borderRadius: '12px',
                color: 'white',
                fontSize: '14px',
                outline: 'none',
                cursor: 'pointer',
                flex: isMobile ? '1' : 'none',
                minWidth: isMobile ? '0' : 'auto'
              }}
            >
              {membershipTypes.map(type => (
                <option key={type.id} value={type.id} style={{ background: colors.bgTertiary, }}>
                  {type.icon} {isMobile ? type.name.split(' ')[0] : type.name}
                </option>
              ))}
            </select>

            <select
              value={selectedCategory}
              onChange={(e) => setSelectedCategory(e.target.value)}
              style={{
                padding: '12px 16px',
                background: 'rgba(255, 255, 255, 0.1)',
                border: '1px solid rgba(255, 255, 255, 0.2)',
                borderRadius: '12px',
                color: 'white',
                fontSize: '14px',
                outline: 'none',
                cursor: 'pointer',
                flex: isMobile ? '1' : 'none',
                minWidth: isMobile ? '0' : 'auto'
              }}
            >
              {categories.map(cat => (
                <option key={cat.id} value={cat.id} style={{ background: colors.bgTertiary, }}>
                  {cat.icon} {isMobile && cat.name.length > 10 ? cat.name.substring(0, 10) + '...' : cat.name}
                </option>
              ))}
            </select>

            <button
              onClick={() => setShowOnlyLive(!showOnlyLive)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                padding: '12px 16px',
                background: showOnlyLive ? '#ef4444' : 'rgba(255, 255, 255, 0.1)',
                border: '1px solid rgba(255, 255, 255, 0.2)',
                borderRadius: '12px',
                color: 'white',
                fontSize: '14px',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                flex: isMobile ? '1' : 'none',
                justifyContent: 'center'
              }}
            >
              <div style={{
                width: '8px',
                height: '8px',
                borderRadius: '50%',
                background: showOnlyLive ? 'white' : '#ef4444'
              }} />
              {isMobile ? 'Live' : 'Live Only'}
            </button>
          </div>
        </div>

        {/* Error Display */}
        {error && (
          <div style={{
            background: 'rgba(239, 68, 68, 0.1)',
            border: '1px solid rgba(239, 68, 68, 0.3)',
            borderRadius: '12px',
            padding: '16px',
            marginBottom: '24px',
            color: '#fca5a5',
            display: 'flex',
            alignItems: 'center',
            gap: '12px'
          }}>
            <AlertCircle size={20} />
            Error: {error}
          </div>
        )}

        {/* Loading State */}
        {loading ? (
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '60px',
            color: '#888'
          }}>
            <div style={{
              width: '40px',
              height: '40px',
              border: '4px solid #333',
              borderTop: '4px solid #00d4aa',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite',
              marginRight: '16px'
            }} />
            Loading sesh rooms...
          </div>
        ) : (
          <>
            {/* Rooms Grid - Mobile responsive */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(350px, 1fr))',
              gap: isMobile ? '16px' : '20px'
            }}>
              {filteredRooms.map((room) => (
                <div key={room.id} style={{
                  background: colors.bgTertiary,
                  border: '1px solid #333',
                  borderRadius: '16px',
                  overflow: 'hidden',
                  transition: 'all 0.3s ease',
                  cursor: 'pointer'
                }}
                onMouseEnter={(e) => {
                  if (!isMobile) {
                    e.currentTarget.style.borderColor = room.is_public ? '#00d4aa' :'#8b5cf6';
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 8px 16px rgba(16, 185, 129, 0.2)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isMobile) {
                    e.currentTarget.style.borderColor = '#333';
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = 'none';
                  }
                }}
                >
                  <div style={{ padding: isMobile ? '16px' : '20px' }}>
                    <div style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'flex-start',
                      marginBottom: '12px'
                    }}>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                          <h3 style={{
                            margin: 0,
                            fontSize: isMobile ? '15px' : '16px',
                            fontWeight: '600',
                            color: '#e5e5e5',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                          }}>
                            {room.title}
                          </h3>
                          {!room.is_public && <Lock size={12} style={{ color: '#8b5cf6', flexShrink: 0 }} />}
                        </div>
                        
                        <div style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                          marginBottom: '8px'
                        }}>
                          <img
                            src={room.host?.cover_image_url ||room.host?.profile_image_url}
                            alt={room.host?.username}
                            style={{
                              width: isMobile ? '28px' : '36px',
                              height: isMobile ? '28px' : '36px',
                              borderRadius: '50%'
                            }}
                          />
                          <img 
                          src={getSmokerEmoji(room.host?.smoker_level)}
                          alt={`${room.host?.smoker_level} level`}
                          style={{
                            width: isMobile ? '28px' : '36px',
                            height: isMobile ? '28px' : '36px',
                            borderRadius: '50%',
                            objectFit: 'cover'
                          }}
                        />
                          <span style={{ fontSize: isMobile ? '12px' : '15px', color: '#888', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {room.host?.profile_display_name||room.host?.username}
                          </span>
                          {/* <span style={{ fontSize: '13px', color: '#888' }}>•</span>
                          <span style={{ fontSize: isMobile ? '12px' : '15px', color: '#888' }}>
                            {isMobile ? new Date(room.created_at).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'}) :new Date(room.created_at).toLocaleString([], {
                              year: 'numeric',
                              month: '2-digit', 
                              day: '2-digit',
                              hour: '2-digit', 
                              minute: '2-digit'
                            }) }
                          </span> */}
                        </div>
                      </div>
                      
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', alignItems: 'flex-end' }}>
                        {/* Live/Offline Status */}
                        <div style={{
                          padding: '4px 8px',
                          background: room.is_live ? (room.is_public ? '#00d4aa' :'#8b5cf6') : '#666',
                          borderRadius: '8px',
                          fontSize: '10px',
                          fontWeight: '600',
                          color: 'white',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '4px',
                          flexShrink: 0
                        }}>
                          <div style={{
                            width: '6px',
                            height: '6px',
                            borderRadius: '50%',
                            background: 'white',
                            animation: room.is_live ? 'pulse 2s infinite' : 'none'
                          }} />
                          {room.is_live ? 'LIVE' : 'OFF'}
                        </div>

                        {/* Membership Badge */}
                        {(() => {
                          const userMembership = room.members?.find(member => member.user_id === user?.id);
                          if (!userMembership) return null;
                          
                          const membershipColors = {
                            'creator': '#ff6b35',
                            'admin': '#e74c3c',
                            'member': '#00d4aa',
                            'pending': '#f39c12',
                            'invited': '#9b59b6',
                            'viewer': '#6c757d'
                          };
                          
                          const membershipIcons = {
                            'creator': '👑',
                            'admin': '🛡️',
                            'member': '✓',
                            'pending': '⏳',
                            'invited': '📩',
                            'viewer': '👁️'
                          };

                          return (
                            <div style={{
                              padding: '3px 6px',
                              background: membershipColors[userMembership.membership_type] || '#6c757d',
                              borderRadius: '6px',
                              fontSize: '9px',
                              fontWeight: '600',
                              color: 'white',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '3px',
                              textTransform: 'uppercase',
                              letterSpacing: '0.5px'
                            }}>
                              <span>{membershipIcons[userMembership.membership_type] || '•'}</span>
                              {userMembership.membership_type}
                            </div>
                          );
                        })()}
                      </div>
                    </div>

                    {/* Room Info */}
                    <div style={{
                      padding: isMobile ? '10px' : '12px',
                      background: colors.bgCard,
                      borderRadius: '8px',
                      marginBottom: '12px'
                    }}>
                      <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: room.strain ? '8px' : '0'
                      }}>
                        <span style={{ fontSize: isMobile ? '11px' : '12px', color: '#888' }}>Category:</span>
                        <span style={{
                          fontSize: isMobile ? '11px' : '12px',
                          fontWeight: '600',
                          color: '#00d4aa'
                        }}>
                          {isMobile ? 
                            (categories.find(cat => cat.id === room.category)?.name?.split(' ')[0] || room.category) :
                            (categories.find(cat => cat.id === room.category)?.name || room.category)
                          }
                        </span>
                      </div>
                      {room.strain && (
                        <div style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center'
                        }}>
                          <span style={{ fontSize: isMobile ? '11px' : '12px', color: '#888' }}>Strain:</span>
                          <span style={{
                            fontSize: isMobile ? '11px' : '12px',
                            fontWeight: '600',
                            color: '#10b981'
                          }}>
                            🌿 {room.strain}
                          </span>
                        </div>
                      )}
                    </div>

                    {/* Stats */}
                    <div style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      marginBottom: '16px'
                    }}>
                      <div style={{ display: 'flex', gap: isMobile ? '8px' : '12px' }}>
                        <div style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '4px',
                          fontSize: isMobile ? '11px' : '12px',
                          color: '#888'
                        }}>
                          <Users size={10} style={{ color: '#00d4aa' }} />
                          {room.participant_count || 0}/{room.max_participants}
                        </div>
                        {room.is_public && (
                          <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '4px',
                            fontSize: isMobile ? '11px' : '12px',
                            color: '#888'
                          }}>
                            <Eye size={10} style={{ color: '#8b5cf6' }} />
                            {room.viewer_count || 0}
                          </div>
                        )}
                        <div style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '4px',
                          fontSize: isMobile ? '11px' : '12px',
                          color: '#888'
                        }}>
                          <MessageCircle size={10} style={{ color: '#f59e0b' }} />
                          {room.message_count || 0}
                        </div>
                        <span style={{ fontSize: '13px', color: '#888' }}>Created at:</span>
                        <span style={{ fontSize: '13px', color: '#888' }}>•</span>
                          <span style={{ fontSize: isMobile ? '11px' : '12px', color: '#888' }}>
                            {isMobile ? new Date(room.created_at).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'}) :new Date(room.created_at).toLocaleString([], {
                              year: 'numeric',
                              month: '2-digit', 
                              day: '2-digit',
                              hour: '2-digit', 
                              minute: '2-digit'
                            }) }
                          </span>
                      </div>
                    </div>

                    {/* Tags - Show fewer on mobile */}
                    <div style={{ 
                      display: 'flex', 
                      flexWrap: 'wrap', 
                      gap: '4px', 
                      marginBottom: '16px',
                      minHeight: '20px' // This keeps buttons in same position always
                    }}>
                      {room.tags && room.tags.length > 0 && (
                        <>
                          {room.tags.slice(0, isMobile ? 2 : 4).map((tag, i) => (
                            <span key={i} style={{
                              padding: '2px 6px',
                              background: '#333',
                              borderRadius: '4px',
                              fontSize: '10px',
                              color: '#888'
                            }}>
                              #{tag}
                            </span>
                          ))}
                          {room.tags.length > (isMobile ? 2 : 4) && (
                            <span style={{
                              padding: '2px 6px',
                              background: '#333',
                              borderRadius: '4px',
                              fontSize: '10px',
                              color: '#888'
                            }}>
                              +{room.tags.length - (isMobile ? 2 : 4)} more
                            </span>
                          )}
                        </>
                      )}
                    </div>

                    {/* Join Button */}
                   {(() => {
                      const userMembership = room.members?.find(member => member.user_id === user?.id);
                      console.log('userzMEMEBER SHIP: ', userMembership)
                      const canStartStream = userMembership && ['creator', 'admin', 'member'].includes(userMembership.membership_type);
                      console.log('canStartStream SHIP: ', canStartStream)
                      console.log('ggggg')
                      

                      const isInvited = userMembership && userMembership.membership_type === 'invited' && !room.is_public;

                      console.log(isInvited)
                      console.log(!room.is_public)
                      if (!room.is_live && canStartStream) {
                        // Show Room Offline + Activate button for members/creators/admins

                        return (
                          <div style={{ display: 'flex', gap: '8px', width: '100%' }}>
                            <button 
                              disabled={true}
                              style={{
                                flex: 1,
                                padding: '12px',
                                borderRadius: '12px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '8px',
                                border: 'none',
                                cursor: 'not-allowed',
                                backgroundColor: '#333',
                                color: '#666',
                                fontSize: '14px',
                                fontWeight: '600'
                              }}
                            >
                              <VideoOff size={16} />
                              Room Offline
                            </button>
                            <button
                              onClick={async () => {
                                try {
                                  const response = await fetch(`${API_URL}/api/rooms/${room.id}/start-stream`, {
                                    method: 'POST',
                                    headers: { 'Content-Type': 'application/json' },
                                    credentials: 'include',
                                    body: JSON.stringify({
                                      title: room.title || room.name,
                                      description: room.description || ''
                                    })
                                  });
                                  const data = await response.json();
                                  if (data.success) {
                                    showNotification('Room is now live!');
                                    fetchRooms();
                                  } else {
                                    showNotification(data.error || 'Failed to start stream', 'error');
                                  }
                                } catch (error) {
                                  showNotification('Failed to start stream', 'error');
                                }
                              }}
                              style={{
                                padding: '12px 16px',
                                background: room.is_public ? '#00d4aa' :'#8b5cf6',
                                border: 'none',
                                borderRadius: '12px',
                                cursor: 'pointer',
                                color: 'white',
                                fontSize: '14px',
                                fontWeight: '600',
                                whiteSpace: 'nowrap'
                              }}
                            >
                              Activate Sesh Room
                            </button>
                          </div>
                        );
                      } else if (isInvited) {
                             console.log('HEHEHEHEHHE')
                              return (
                                <button 
                                  onClick={() => {
                                    setSelectedInvitedRoom(room);
                                    setShowInvitationModal(true);
                                  }}
                                  style={{
                                    width: '100%',
                                    padding: '12px',
                                    borderRadius: '12px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '8px',
                                    border: 'none',
                                    cursor: 'pointer',
                                    backgroundColor: '#8b5cf6',
                                    color: 'white',
                                    fontSize: '14px',
                                    fontWeight: '600',
                                    transition: 'all 0.3s ease'
                                  }}
                                >
                                  <UserPlus size={16} />
                                  Accept Invitation
                                </button>
                              );
                            }else {
                        // Original single button for everyone else
                          console.log(room)
                        return (
                          <button 
                            onClick={() => handleJoinRoom(room, room.type == 'public')}
                            disabled={
                              !room.is_live || 
                              !isAuthenticated || 
                              (userMembership?.membership_type === 'pending')
                            }
                                                    
                            style={{
                              width: '100%',
                              padding: '12px',
                              borderRadius: '12px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: '8px',
                              border: 'none',
                              cursor: (
                                room.is_live && 
                                isAuthenticated && 
                                userMembership?.membership_type !== 'pending'
                              ) ? 'pointer' : 'not-allowed',
                              backgroundColor: (room.is_live && isAuthenticated) ? (room.is_public ? '#00d4aa' :'#8b5cf6') : colors.border,
                              color: (room.is_live && isAuthenticated) ? 'white' : '#666',
                              fontSize: '14px',
                              fontWeight: '600',
                              transition: 'all 0.3s ease'
                            }}
                          >
                            {!isAuthenticated ? (
                              <>
                                <Lock size={16} />
                                Login to Join
                              </>
                            ) : !room.is_live ? (
                              <>
                                <VideoOff size={16} />
                                Room Offline
                              </>
                            ) : (
                              <>
                                <Video size={16} />
                                {room.is_public ? "Join Sesh" : userMembership.membership_type === 'pending' ? "Request Pending":"Join Private Sesh"}
                              </>
                            )}
                          </button>
                        );
                      }
                    })()}
                  </div>
                </div>
              ))}
            </div>

            {/* Empty State */}
            {filteredRooms.length === 0 && !loading && (
              <div style={{
                textAlign: 'center',
                padding: isMobile ? '40px 20px' : '60px 20px',
                color: '#888'
              }}>
                <Leaf size={isMobile ? 48 : 64} style={{ marginBottom: '16px', opacity: 0.3 }} />
                <h3 style={{ margin: '0 0 8px 0', fontSize: isMobile ? '18px' : '20px', fontWeight: '600' }}>
                  No sesh rooms found
                </h3>
                <p style={{ margin: '0 0 24px 0', fontSize: isMobile ? '14px' : '16px' }}>
                  {searchQuery || selectedCategory || showOnlyLive 
                    ? "Try adjusting your filters or search terms"
                    : "Be the first to start a sesh room!"
                  }
                </p>
                {isAuthenticated && (
                  <button
                    onClick={() => setShowCreateRoom(true)}
                    style={{
                      padding: isMobile ? '12px 24px' : '16px 32px',
                      background: 'linear-gradient(135deg, #00d4aa 0%, #10b981 100%)',
                      color: 'white',
                      border: 'none',
                      borderRadius: '16px',
                      cursor: 'pointer',
                      fontSize: isMobile ? '14px' : '16px',
                      fontWeight: '600',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      margin: '0 auto'
                    }}
                  >
                    <Plus size={isMobile ? 18 : 20} />
                    Create First Sesh Room
                  </button>
                )}
              </div>
            )}
          </>
        )}

        {/* Community Stats - Mobile responsive grid */}
        <div style={{
          marginTop: isMobile ? '32px' : '48px',
          display: 'grid',
          gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: isMobile ? '12px' : '16px'
        }}>
          <div style={{
            background: colors.bgTertiary,
            border: '1px solid #333',
            borderRadius: '16px',
            padding: isMobile ? '16px' : '20px',
            textAlign: 'center'
          }}>
            <div style={{
              width: isMobile ? '40px' : '48px',
              height: isMobile ? '40px' : '48px',
              background: 'linear-gradient(135deg, #00d4aa 0%, #10b981 100%)',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 12px auto'
            }}>
              <Users size={isMobile ? 20 : 24} style={{ color: 'white' }} />
            </div>
            <h3 style={{ margin: '0 0 4px 0', fontSize: isMobile ? '20px' : '24px', fontWeight: '700', color: '#e5e5e5' }}>
              {rooms.reduce((total, room) => total + (room.participant_count || 0), 0)}
            </h3>
            <p style={{ margin: 0, fontSize: isMobile ? '12px' : '14px', color: '#888' }}>
              {isMobile ? 'Participants' : 'Active Participants'}
            </p>
          </div>

          <div style={{
            background: colors.bgTertiary,
            border: '1px solid #333',
            borderRadius: '16px',
            padding: isMobile ? '16px' : '20px',
            textAlign: 'center'
          }}>
            <div style={{
              width: isMobile ? '40px' : '48px',
              height: isMobile ? '40px' : '48px',
              background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 12px auto'
            }}>
              <Video size={isMobile ? 20 : 24} style={{ color: 'white' }} />
            </div>
            <h3 style={{ margin: '0 0 4px 0', fontSize: isMobile ? '20px' : '24px', fontWeight: '700', color: '#e5e5e5' }}>
              {rooms.filter(room => room.is_live).length}
            </h3>
            <p style={{ margin: 0, fontSize: isMobile ? '12px' : '14px', color: '#888' }}>
              Live Rooms
            </p>
          </div>

          <div style={{
            background: colors.bgTertiary,
            border: '1px solid #333',
            borderRadius: '16px',
            padding: isMobile ? '16px' : '20px',
            textAlign: 'center'
          }}>
            <div style={{
              width: isMobile ? '40px' : '48px',
              height: isMobile ? '40px' : '48px',
              background: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 12px auto'
            }}>
              <Eye size={isMobile ? 20 : 24} style={{ color: 'white' }} />
            </div>
            <h3 style={{ margin: '0 0 4px 0', fontSize: isMobile ? '20px' : '24px', fontWeight: '700', color: '#e5e5e5' }}>
              {rooms.reduce((total, room) => total + (room.viewer_count || 0), 0)}
            </h3>
            <p style={{ margin: 0, fontSize: isMobile ? '12px' : '14px', color: '#888' }}>
              {isMobile ? 'Viewers' : 'Total Viewers'}
            </p>
          </div>

          <div style={{
            background: colors.bgTertiary,
            border: '1px solid #333',
            borderRadius: '16px',
            padding: isMobile ? '16px' : '20px',
            textAlign: 'center'
          }}>
            <div style={{
              width: isMobile ? '40px' : '48px',
              height: isMobile ? '40px' : '48px',
              background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 12px auto'
            }}>
              <MessageCircle size={isMobile ? 20 : 24} style={{ color: 'white' }} />
            </div>
            <h3 style={{ margin: '0 0 4px 0', fontSize: isMobile ? '20px' : '24px', fontWeight: '700', color: '#e5e5e5' }}>
              {rooms.reduce((total, room) => total + (room.message_count || 0), 0)}
            </h3>
            <p style={{ margin: 0, fontSize: isMobile ? '12px' : '14px', color: '#888' }}>
              {isMobile ? 'Messages' : 'Messages'}
            </p>
          </div>
        </div>

        {/* Call to Action - Mobile responsive */}
        {isAuthenticated && (
          <div style={{
            marginTop: isMobile ? '32px' : '48px',
            textAlign: 'center',
            padding: isMobile ? '24px' : '40px',
            background: colors.bgTertiary,
            borderRadius: '24px',
            border: '1px solid #333'
          }}>
            <div style={{ marginBottom: '16px' }}>
              <span style={{ fontSize: isMobile ? '40px' : '48px', marginBottom: '16px', display: 'block' }}>🌿</span>
              <h3 style={{
                margin: '0 0 8px 0',
                fontSize: isMobile ? '20px' : '24px',
                fontWeight: '700',
                color: '#e5e5e5'
              }}>
                Ready to start your own sesh?
              </h3>
              <p style={{
                margin: 0,
                color: '#888',
                fontSize: isMobile ? '14px' : '16px',
                maxWidth: '500px',
                margin: '0 auto'
              }}>
                Create your own room, invite friends, or start a public session. 
                Share strains, stories, and good vibes with the community.
              </p>
            </div>
            <button
              onClick={() => setShowCreateRoom(true)}
              style={{
                padding: isMobile ? '16px 32px' : '20px 40px',
                background: 'linear-gradient(135deg, #00d4aa 0%, #10b981 100%)',
                color: 'white',
                border: 'none',
                borderRadius: '16px',
                cursor: 'pointer',
                fontSize: isMobile ? '16px' : '18px',
                fontWeight: '600',
                transition: 'all 0.3s ease',
                boxShadow: '0 8px 20px rgba(16, 185, 129, 0.4)',
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                margin: '0 auto'
              }}
              onMouseEnter={(e) => {
                if (!isMobile) {
                  e.currentTarget.style.transform = 'scale(1.05)';
                  e.currentTarget.style.boxShadow = '0 12px 24px rgba(16, 185, 129, 0.5)';
                }
              }}
              onMouseLeave={(e) => {
                if (!isMobile) {
                  e.currentTarget.style.transform = 'scale(1)';
                  e.currentTarget.style.boxShadow = '0 8px 20px rgba(16, 185, 129, 0.4)';
                }
              }}
            >
              <Sparkles size={isMobile ? 20 : 24} />
              Create Your Sesh Room
            </button>
          </div>
        )}
      </div>

      {/* Create Room Modal */}
      <CreateSeshRoomModal
        isOpen={showCreateRoom}
        onClose={() => setShowCreateRoom(false)}
        onCreateRoom={handleCreateRoom}
      />

      <PrivateRoomsModal
        isOpen={showPrivateRooms}
        onClose={() => setShowPrivateRooms(false)}
        currentUser={user}
        fetchRooms={fetchRooms}           // Add this
        setSelectedRoom={setSelectedRoom} // Add this
        setCurrentRoom={setCurrentRoom}   // Add this
        setUserRole={setUserRole}         // Add this
        joinVideoRoom={joinVideoRoom}     // Add this
      />
      <JoinInvitationModal
        isOpen={showInvitationModal}
        onClose={() => {
          setShowInvitationModal(false);
          setSelectedInvitedRoom(null);
        }}
        room={selectedInvitedRoom}
        currentUser={user}
        onResponse={handleInvitationResponse}
      />

      <PendingInvitationsModal
        isOpen={showPendingInvitations}
        onClose={() => setShowPendingInvitations(false)}
        currentUser={user}
        onInvitationResponse={handleInvitationResponse}
      />

      <PendingRoomsManagementModal
        isOpen={showPendingRoomsManagement}
        onClose={() => setShowPendingRoomsManagement(false)}
        currentUser={user}
        showNotification={showNotification}
      />
      {showGiphyPicker && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          zIndex: 2000,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '20px'
        }}>
          <div style={{
            width: '100%',
            maxWidth: isMobile ? '100%' : '600px',
            maxHeight: isMobile ? '100%' : '70vh',
            background: colors.bgTertiary1,
            borderRadius: '16px',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            boxShadow: '0 20px 60px rgba(0, 0, 0, 0.5)'
          }}>
            {/* Header */}
            <div style={{
              padding: '16px',
              borderBottom: '1px solid #333',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              background: colors.bgTertiary,
              flexShrink: 0
            }}>
              <h3 style={{ margin: 0, color: 'white', fontSize: '18px' }}>Choose a GIF</h3>
              <button
                onClick={() => {
                  setShowGiphyPicker(false);
                  setGiphySearch('');
                }}
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#888',
                  cursor: 'pointer',
                  padding: '8px'
                }}
              >
                <X size={24} />
              </button>
            </div>

            {/* Search Bar */}
            <div style={{ 
              padding: '16px', 
              background: colors.bgTertiary,
              flexShrink: 0
            }}>
              <div style={{ position: 'relative' }}>
                <Search
                  size={18}
                  style={{
                    position: 'absolute',
                    left: '12px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    color: '#888'
                  }}
                />
                <input
                  type="text"
                  value={giphySearch}
                  onChange={(e) => {
                    setGiphySearch(e.target.value);
                    searchGiphy(e.target.value);
                  }}
                  placeholder="Search GIPHY..."
                  style={{
                    width: '100%',
                    padding: '12px 12px 12px 40px',
                    border: '1px solid #333',
                    borderRadius: '12px',
                    background: colors.bgCard,
                    color: '#e5e5e5',
                    fontSize: '16px',
                    outline: 'none',
                    boxSizing: 'border-box'
                  }}
                />
              </div>
            </div>

            {/* GIF Grid */}
            <div style={{
              flex: 1,
              overflowY: 'auto',
              padding: '16px',
              background: colors.bgPrimary
            }}>
              {giphyLoading ? (
                <div style={{ textAlign: 'center', padding: '48px', color: '#888' }}>
                  Loading GIFs...
                </div>
              ) : (
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(2, 1fr)',
                  gap: '12px'
                }}>
                  {giphyResults.map((gif) => (
                    <div
                      key={gif.id}
                      onClick={() => selectGif(gif)}
                      style={{
                        cursor: 'pointer',
                        borderRadius: '8px',
                        overflow: 'hidden',
                        transition: 'transform 0.2s ease',
                        border: '2px solid transparent'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'scale(1.05)';
                        e.currentTarget.style.borderColor = '#00d4aa';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'scale(1)';
                        e.currentTarget.style.borderColor = 'transparent';
                      }}
                    >
                      <img
                        src={gif.images.fixed_height.url}
                        alt={gif.title}
                        style={{
                          width: '100%',
                          height: 'auto',
                          display: 'block'
                        }}
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.8; }
        }
        
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        /* Mobile chat overlay */
        @media (max-width: 768px) {
          .mobile-chat-overlay {
            backdrop-filter: blur(8px);
            background: rgba(0, 0, 0, 0.8);
          }
        }
      `}</style>
    </div>
  );
}